import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
const SenceCardD = () => {
    const { t } = useLang('Delta3AirStation.SenceCardD');
    return (
        <section className={`${styles.SenceCardD} range6 GtmModuleData-section`} id="List-sence-F" data-section-id="SenceCardD">
            <div className="title-box">
                <div className="label">{t('label')}</div>
                <div className="title">{t('title')}</div>
                <div className="subtitle">{t('subtitle')}</div>
            </div>
            <div className="content-box">
                <EcoImg
                    alt={t('title')}
                    pc="https://websiteoss.ecoflow.com/upload/image/1761631845960/sence-d-1-pc.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1761631845960/sence-d-1-pc.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1761659465963/d-1-m.jpg"
                    isOpenLazy
                />
            </div>
        </section>
    );
};

export default SenceCardD;
